import type { ApiResponse, PaginatedData, SuccessResponse } from "@shared/types";
import apiClient from "@/app/api/client";
import type { Item, ItemCreateRequest, ItemUpdateRequest, ListItemsParams } from "../types";

export const itemsService = {
	async list(params: ListItemsParams): Promise<PaginatedData<Item>> {
		const response = await apiClient.get<ApiResponse<PaginatedData<Item>>>("/items", { params });
		return (response.data as SuccessResponse<PaginatedData<Item>>).data;
	},

	async getById(id: string): Promise<Item> {
		const response = await apiClient.get<SuccessResponse<Item>>(`/items/${id}`);
		return response.data.data;
	},

	async create(data: ItemCreateRequest): Promise<Item> {
		const response = await apiClient.post<SuccessResponse<Item>>("/items", data);
		return response.data.data;
	},

	async update(id: string, data: ItemUpdateRequest): Promise<Item> {
		const response = await apiClient.patch<SuccessResponse<Item>>(`/items/${id}`, data);
		return response.data.data;
	},

	async remove(id: string): Promise<void> {
		await apiClient.delete(`/items/${id}`);
	},
};
